import { EMPTY_FIELD } from 'constants/emptyField';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { BooleanField, NumberField, TextField } from 'shared/react-admin/Fields';

export const CommissionsTabsConditions: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '160px' } } }}>
      <TableRowWrapper label={translate('app.commissions.zeroed')}>
        <BooleanField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.zeroed')}
          source="rate.zeroed"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.percent')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.percent')}
          source="rate.percent"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.fixed')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.fixed')}
          source="rate.fix"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.max')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.max')}
          source="rate.max"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.min')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.min')}
          source="rate.min"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.calculationMethod')}>
        <TextField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.calculationMethod')}
          source="calculationMethod.description"
        />
      </TableRowWrapper>
    </CardTable>
  );
};
